query TestLabels {
	wsdk_test_labels {
		custom_fields
		environments
		flows
	}
}
